module.exports = __webpack_public_path__ + "static/bayer-e7ba74e95dec05b0c1c373e1d57f16bd.png";